import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const WeaningIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M6.46,4l1.9,1.9h8.57a1,1,0,0,0,1-1,.94.94,0,0,0-.28-.7A1,1,0,0,0,16.93,4h-4V1.12a1,1,0,0,0-1-1,.94.94,0,0,0-.7.28,1,1,0,0,0-.29.71V4h-4A1.11,1.11,0,0,0,6.46,4ZM3.27,3.13,1.9,4.49,6.25,8.82A3.6,3.6,0,0,0,6,10.26v11a2.48,2.48,0,0,0,.52,1.58,2.35,2.35,0,0,0,1.87.89h7a2.45,2.45,0,0,0,1.57-.51,2.34,2.34,0,0,0,.91-1.86V20.34l2.78,2.77L22,21.75Zm14.58,12V10.51a3.58,3.58,0,0,0-3.59-3.58H9.68l2,2h2.6a1.57,1.57,0,0,1,1.6,1.6v2.61ZM7.94,11.89V10.64l1.24,1.25Zm2.64,2a1.06,1.06,0,0,0,.48-.11l4.8,4.68v2.95a.38.38,0,0,1-.11.29.42.42,0,0,1-.29.11H7.94v-3h2.64a1,1,0,0,0,.71-.29.94.94,0,0,0,.28-.7,1,1,0,0,0-1-1H7.94v-3Z" />
    </SvgIcon>
  )
}
export default WeaningIcon
